// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class DoubleValue implements flatbuffers.IUnpackableObject<DoubleValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DoubleValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDoubleValue(bb: flatbuffers.ByteBuffer, obj?: DoubleValue): DoubleValue {
    return (obj || new DoubleValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDoubleValue(
    bb: flatbuffers.ByteBuffer,
    obj?: DoubleValue,
  ): DoubleValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DoubleValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  static startDoubleValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldFloat64(0, value, 0.0);
  }

  static endDoubleValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createDoubleValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    DoubleValue.startDoubleValue(builder);
    DoubleValue.addValue(builder, value);
    return DoubleValue.endDoubleValue(builder);
  }

  unpack(): DoubleValueT {
    return new DoubleValueT(this.value());
  }

  unpackTo(_o: DoubleValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): DoubleValueT {
    const t = new DoubleValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class DoubleValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0.0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return DoubleValue.createDoubleValue(builder, this.value);
  }

  clone(): DoubleValueT {
    const obj = new DoubleValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: DoubleValueT): boolean {
    if (!Object.is(this.value, other.value)) return false;
    return true;
  }
}

export function verifyDoubleValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
  } finally {
    verifier.popDepth();
  }
}
